import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/services/utils';

interface UserAvatarProps {
    email?: string | null;
    name?: string | null;
    pictureUrl?: string | null;
    className?: string;
    onClick?: () => void;
}

export function UserAvatar({ email, name, pictureUrl, className, onClick }: UserAvatarProps) {
    const source = name || email;
    const initials = source ? source.charAt(0).toUpperCase() : 'U';

    return (
        <Avatar className={cn(onClick && 'cursor-pointer', className)} onClick={onClick}>
            {pictureUrl && <AvatarImage src={pictureUrl} alt={name ?? email ?? 'User avatar'} />}
            <AvatarFallback className="bg-purple-100 text-purple-600 font-medium">
                {initials}
            </AvatarFallback>
        </Avatar>
    );
}
